export default "__VITE_ASSET__CHnKOLLX__"